import Graph from "./Graph";

export default Graph;
